<a
  data-test="opRC_t98"
  class="dropdown__menu-link notifications__menu-item"
  *ngIf="notifications$ | async | notNull as notifications"
>
  Notifications ({{ notifications.length }} unread)

  <div data-test="YENAiPnb" class="notifications-container">
    <ul
      data-test="gIiwyq-3"
      *ngIf="notifications.length === 0"
      class="notification-list dropdown__wrap"
    >
      <li data-test="YU1TsV2G" class="item-empty">
        <span data-test="9mZE7Wcq">Nothing found.</span>
      </li>
    </ul>

    <ul
      data-test="RV_5M1Zx"
      class="notification-list dropdown__wrap"
      *ngIf="notifications.length > 0"
    >
      <li
        data-test="K7690Hb8"
        class="item"
        *ngFor="let notification of notifications"
        (click)="showConfirmDialog(notification)"
      >
        <div data-test="pkPdUIIB" class="notification-title">
          {{ notification.title }}
        </div>
        <div data-test="-PoeeA7M" class="notification-content">
          {{ notification.content }}
        </div>
      </li>
    </ul>
  </div>
</a>
